import React from 'react';
import { Button } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux'
import { updateChildrensCount } from '../actions/childrens';
import { updateSection } from '../actions/ui';
import { sectionIds } from '../constants';

const ChildrenInput = (props) => {
  const {
    label="",
  } = props

  const count = useSelector((state) => state.childrens.childrensCount);
  const dispatch = useDispatch();

  const updateCount = (isLess) => {
    if ((count===1 && isLess) || (count===10 && !isLess) ) return;
    const newCount = isLess ? count-1 : count+1;
    dispatch(updateChildrensCount(newCount));
    dispatch(updateSection(sectionIds.PARENTS_AND_CHILDREN));
  }

  const renderCircularBtn = (isLess=false) => {
    return (
      <Button
        className='amount-btn-touchable'
        onClick={()=>updateCount(isLess)}
      >
        <p className='amount-btn'>
          {isLess ? '-' : '+'}
        </p>
      </Button>
    )
  }

  return (
    <>
      <p className='body-copy mb-8'>{label}</p>
      <div className='amount-children-container mb-40'>
      <p className='body-copy mb-0' style={{marginBottom:0,marginTop:0}}>Number of children</p>

        <div className='amount-btn-container'>
          {renderCircularBtn(true)}
          <p className='cta'>{count}</p>
          {renderCircularBtn()}

        </div>
      </div>
    </>
  )
}

export default ChildrenInput;

